import React, { useState } from "react";
import TableMaster from "./TableMaster";
import Monthly_Yealy_Comparison from "./TableView/Monthly_Yealy_Comparison";
import MonthWiseGraph from "./GraphView/MonthWiseGraph";
import MonthlyYearlyGraph from "./GraphView/MonthlyYearlyGraph";
import IreMonthWiseTable from "./TableView/IreMonthWiseTable";
import IREController from "./IREController";

const IREMaster = () => {
  const [monthWiseData, setMonthWiseData] = useState(null);
  const [summaryData, setSummaryData] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [IREFilteredData, setIREFilteredData] = useState(null);
  const [activeMetrics, setActiveMetrics] = useState(["JUMBO"]);
  const [openStates, setOpenStates] = useState({
    "Financial Year": false,
    Month: false,
    Metrics: false,
  });
  const handleReset = () => {
    setOpenStates({
      "Financial Year": false,
      Month: false,
      Metrics: false,
    });
  };
  const style = { height: "100px", width: "200px", border: "1px solid black" };
  return (
    <div className="">
      {/* //////////////////////////////////////////////////////////////////////////////////////////// */}
      {/* //////////////////////////////////////////////////////////////////////////////////////////// */}

      <div className="row">
        <div className="col-md-8">
          {" "}
          <div className="newUiBody">
            {
              <Monthly_Yealy_Comparison
                data={monthWiseData}
                setSelectedDate={setSelectedDate}
              />
            }
          </div>
        </div>
        <div className="col-md-4">
          <div className="newUiBody">
            {" "}
            <MonthlyYearlyGraph
              data={monthWiseData}
              setSelectedDate={setSelectedDate}
            />
          </div>
        </div>
      </div>
      {/* <div className="sticky-controller">
        <IREController
          data={summaryData}
          openStates={openStates}
          setOpenStates={setOpenStates}
          setActiveMetrics={setActiveMetrics}
          setIREFilteredData={setIREFilteredData}
        />
      </div>

      <div className="row" style={{ zIndex: 1 }} onClick={handleReset}>
        <div className="col-md-12 ">
          <div className="newUiBody">
            {console.log(summaryData)}
            <MonthWiseGraph
              data={IREFilteredData}
              activeMetrics={activeMetrics}
            />
          </div>
        </div>
        <div className="col-md-12 ">
          <div className="newUiBody">
            <IreMonthWiseTable
              data={IREFilteredData}
              activeMetrics={activeMetrics}
            />
          </div>
        </div>
      </div> */}

      {/* //////////////////////////////////////////////////////////////////////////////////////////// */}
      <div className=""></div>
      <div className="border">
        <TableMaster
          date={selectedDate}
          monthWiseData={monthWiseData}
          setMonthWiseData={setMonthWiseData}
          setSummaryData={setSummaryData}
          summaryData={summaryData}
        />
      </div>
    </div>
  );
};
export default IREMaster;
